import { Component, OnInit } from '@angular/core';
import { TranslationsService } from '../../services/translations/translations.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-congratulations',
  templateUrl: './congratulations.component.html',
  styleUrls: ['./congratulations.component.scss'],
})
export class CongratulationsComponent implements OnInit {
  language = '';

  constructor(
    private readonly translationsService: TranslationsService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.language = this.translationsService.getCurrentLanguage();
  }

  next(): void {
    this.router.navigate([this.language, 'repatriate']);
  }
}
